import { useBranding } from "../contexts/BrandingContext";
import BrandLogo from "./BrandLogo";

/** Login / signup header — nothing until white-label API completes on partner domains. */
export function AuthBrand() {
  const brand = useBranding();
  const { showBrandSkeleton, isWhiteLabel, isBrandingReady, isDefaultHost, name, company_name } =
    brand;

  if (showBrandSkeleton || !isBrandingReady) {
    return (
      <div className="auth-brand" aria-busy="true" aria-label="Loading brand">
        <div className="auth-logo brand-logo-skeleton" />
        <div className="auth-brand-text">
          <div className="auth-name brand-text-skeleton" />
          <div className="ping-chip g brand-chip-skeleton" />
        </div>
      </div>
    );
  }

  if (!isWhiteLabel && !isDefaultHost) {
    return <div className="auth-brand auth-brand-empty" aria-hidden="true" />;
  }

  return (
    <div className="auth-brand">
      <BrandLogo className="auth-logo" />
      <div className="auth-brand-text">
        <div className="auth-name">{name}</div>
        <span className="ping-chip g">{company_name || "Workspace"}</span>
      </div>
    </div>
  );
}

export default AuthBrand;
